exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._32vtNpsBmg2hWye8IruUxO{max-width:240px;margin:0 auto 30px;text-align:center}._1tY-Lra36CSIM4QL0aMY7H{max-width:100%;max-height:140px}", ""]);

// exports
exports.locals = {
	"container": "_32vtNpsBmg2hWye8IruUxO",
	"image": "_1tY-Lra36CSIM4QL0aMY7H"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/organization-image/organization-image.css
// module id = 287
// module chunks = 0 1 2